import { Link } from "@remix-run/react";
import { NewsletterForm } from "~/components/newsletterForm";

export function Footer() {
  return (
    <footer className="bg-white border-t mt-20">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-6xl mx-auto">
          {/* Main Content - 2 Columns */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24 mb-16">
            {/* Left Column - Newsletter */}
            <div className="max-w-md">
              <NewsletterForm />
            </div>

            {/* Right Column - Links */}
            <div className="grid grid-cols-2 gap-x-12 gap-y-8">
              {/* Espacios */}
              <div>
                <h4 className="font-semibold text-lg mb-3">Espacios</h4>
                <nav className="space-y-2">
                  <Link
                    to="/solicitar-espacio"
                    className="block text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    Solicita un espacio
                  </Link>
                  <Link
                    to="/cuenta/espacios"
                    className="block text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    Sube un espacio
                  </Link>
                  <Link
                    to="/suscripcion"
                    className="block text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    Planes y Precios
                  </Link>
                </nav>
              </div>

              {/* Prensa */}
              <div>
                <h4 className="font-semibold text-lg mb-3">Prensa</h4>
                <nav className="space-y-2">
                  <Link
                    to="/prensa"
                    className="block text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    Sala de Prensa
                  </Link>
                </nav>
              </div>

              {/* Legal */}
              <div>
                <h4 className="font-semibold text-lg mb-3">Legal</h4>
                <nav className="space-y-2">
                  <Link
                    to="/politica-de-privacidad"
                    className="block text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    Política de Privacidad
                  </Link>
                  <Link
                    to="/politica-de-cookies"
                    className="block text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    Política de Cookies
                  </Link>
                  <Link
                    to="/politica-de-comisiones"
                    className="block text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    Política de Comisiones
                  </Link>
                  <Link
                    to="/politica-de-suscripciones"
                    className="block text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    Política de Suscripciones
                  </Link>
                </nav>
              </div>
            </div>
          </div>

          {/* Bottom Section - Copyright + Enisa */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 pt-8 border-t">
            <p className="text-sm text-muted-foreground text-center md:text-left">
              © {new Date().getFullYear()} Compartir Espacios. Todos los derechos reservados.
            </p>
            <a
              href="https://www.enisa.es"
              target="_blank"
              rel="noopener noreferrer"
              className="shrink-0"
              title="Financiada por Enisa"
            >
              <img
                src="/logos/enisa-sello-horizontal.png"
                alt="Financiada por Enisa - Ministerio de Industria y Turismo"
                width={216}
                height={144}
                loading="lazy"
                className="h-24 w-auto"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
